export default {
	language: 'العربية',
	banner_title: 'Customer Satisfaction Survey',
	banner_text1: 'To achieve and maintain on-going high quality of the services we deliver, Customer Satisfaction Surveys are sent out to the client project manager periodically and at the completion of major milestones.',
	banner_text2: 'These reports allow us to monitor the work, improve performance in timely manner and to serve you better.',
	banner_text3: 'Thank you for taking the time to fill out this form.',
	projectInfo_projectName: 'Project Name',
	projectInfo_client: 'Client',
	projectInfo_surveyDate: 'Survey Date',
	projectInfo_projectTeamMembers: 'Project Team Members',
	projectInfo_projectManager: 'Project Manager',
	projectInfo_customerProjectManager: 'Customer Project Manager',
	survey_notSatisfied: 'Not Satisfied',
	survey_satisfied: 'Completely Satisfied',
	survey_filledBy: 'Filled by',
	survey_email: 'Email',
	survey_alreadyFilled: 'Displaying Survey Responses.',
	survey_loading: 'Loading survey...',
	survey_notFound: 'The survey is not valid'
};
